module.exports = __webpack_public_path__ + "assets/img/52b3c94265f40a3c805ff3058d337ba3.svg";